var map = {
	"./404.svg": 937,
	"./Categories.png": 938,
	"./Edit-menu.svg": 939,
	"./Egg.svg": 940,
	"./Emaier-Header.png": 941,
	"./Qr-4.png": 942,
	"./_duplicate.svg": 943,
	"./_overview.svg": 944,
	"./add-white.svg": 945,
	"./alert.svg": 946,
	"./all_category.svg": 947,
	"./archive.svg": 948,
	"./armchair.svg": 949,
	"./arrow-circle-right.svg": 950,
	"./arrow-left-circle.svg": 951,
	"./arrow-right-circle.svg": 952,
	"./arrow-right.svg": 351,
	"./asc-up-white.svg": 953,
	"./asc.png": 954,
	"./asc.svg": 955,
	"./back-arrow.svg": 956,
	"./barcode-icon.svg": 957,
	"./beverages.svg": 958,
	"./blue-edit-pen.svg": 959,
	"./blue-eye.svg": 960,
	"./box-office.svg": 961,
	"./broken-seat.jpg": 962,
	"./calendar_list.svg": 963,
	"./chevron-down.svg": 964,
	"./chevron-left.svg": 965,
	"./cinema-mamagement-sidebar.svg": 966,
	"./claendar.svg": 301,
	"./clock-1.svg": 967,
	"./clock.svg": 968,
	"./close-button.svg": 698,
	"./close-white.svg": 700,
	"./close-x.svg": 296,
	"./collapse-up.svg": 969,
	"./collapse.svg": 970,
	"./connection-lost.svg": 349,
	"./copy.svg": 971,
	"./copy_image_icon.png": 972,
	"./delete-red-light.svg": 973,
	"./delete-red.svg": 706,
	"./delete.svg": 683,
	"./deliver-icon.svg": 974,
	"./desc-down-white.svg": 975,
	"./desc.svg": 976,
	"./distributors-sidebar.svg": 977,
	"./download.svg": 978,
	"./dragndrop.svg": 979,
	"./dragndrop2.svg": 980,
	"./duplicate.svg": 981,
	"./duplicateScreen.svg": 982,
	"./e-wallet-icon-black.svg": 983,
	"./edit-pen-blue.svg": 984,
	"./edit-pen-white.svg": 985,
	"./edit-pen.svg": 986,
	"./edit.svg": 987,
	"./email.png": 988,
	"./empty-image.svg": 989,
	"./excel.svg": 990,
	"./external-link.svg": 991,
	"./eye.svg": 992,
	"./filter-icon.svg": 993,
	"./flag.svg": 994,
	"./fnb-app-order.svg": 995,
	"./fnb-beverages.svg": 996,
	"./fnb-brownie.svg": 997,
	"./fnb-combo.svg": 998,
	"./fnb-desert.svg": 999,
	"./fnb-eatables.svg": 1000,
	"./fnb-make-your-combo.svg": 1001,
	"./fnb-popcorn.svg": 1002,
	"./fnbtransactionIcon.svg": 1003,
	"./fullscreen-icon.svg": 707,
	"./funnel.svg": 1004,
	"./globe.svg": 1005,
	"./green-tick.svg": 1006,
	"./grid-view.svg": 1007,
	"./hide-password.svg": 352,
	"./home-icon.svg": 1008,
	"./home.svg": 1009,
	"./icon-black-play.svg": 1010,
	"./icon-dot.svg": 1011,
	"./icon-fnb.svg": 1012,
	"./icon-marketing.svg": 1013,
	"./icon-no-seat.png": 1014,
	"./icon-no-seat.svg": 1015,
	"./icon-option.svg": 1016,
	"./icon-poin-of-sale.svg": 1017,
	"./icon-recliner.svg": 1018,
	"./icon-report.svg": 1019,
	"./icon-sofa-dark-1.svg": 1020,
	"./icon-sofa-dark.png": 1021,
	"./icon-sofa-dark.svg": 1022,
	"./icon-sofa.svg": 1023,
	"./importfile.svg": 1024,
	"./info.svg": 701,
	"./info2.svg": 1025,
	"./keyboard-icon.svg": 1026,
	"./kitchen_display.svg": 1027,
	"./language-icon.svg": 297,
	"./left-caret.svg": 1028,
	"./link.svg": 1029,
	"./list-view.svg": 1030,
	"./loading.svg": 353,
	"./lock.svg": 1031,
	"./login-password.png": 354,
	"./login-user.png": 355,
	"./logout.svg": 702,
	"./masters-sidebar.svg": 1032,
	"./merchandise.svg": 1033,
	"./minus.svg": 1034,
	"./movie-pass-svg.svg": 689,
	"./movie-rolling.svg": 1035,
	"./mulitSchedule.svg": 1036,
	"./multicurrency.svg": 1037,
	"./multifnb.svg": 1038,
	"./nav-plus.svg": 1039,
	"./new_filter_icon.svg": 1040,
	"./no-image.svg": 1041,
	"./no-schedule.svg": 133,
	"./non-veg-mark.png": 1042,
	"./non-veg-mark.svg": 1043,
	"./notification.svg": 1044,
	"./open-link-blue.svg": 1045,
	"./openPlanned.svg": 1046,
	"./overview.svg": 1047,
	"./overview2.svg": 1048,
	"./pdf-icon.svg": 1049,
	"./pdf.svg": 1050,
	"./pickup-ticket-icon.svg": 1051,
	"./pickupfnb.svg": 1052,
	"./play.svg": 1053,
	"./plus.svg": 1054,
	"./pointofsale-1.svg": 1055,
	"./pointofsale-2.svg": 1056,
	"./pointofsale.png": 1057,
	"./portfolio.svg": 1058,
	"./pos-fnb-no-itmes.svg": 695,
	"./pos-refresh.svg": 1059,
	"./primary/chevron-down.svg": 1060,
	"./primary/download.svg": 1061,
	"./primary/edit.svg": 1062,
	"./primary/filter.svg": 1063,
	"./primary/printer.svg": 1064,
	"./print-icon.svg": 1065,
	"./print.svg": 1066,
	"./question.svg": 1067,
	"./question1.svg": 1068,
	"./question2.svg": 708,
	"./question3.svg": 1069,
	"./recliner-1.svg": 1070,
	"./recliner.png": 1071,
	"./refund-icon.svg": 1072,
	"./reload-icon-pos.svg": 1073,
	"./reload-icon.svg": 1074,
	"./restore.svg": 1075,
	"./right-caret.svg": 1076,
	"./role-management-sidebar.svg": 1077,
	"./save.svg": 1078,
	"./schedule-icon.svg": 1079,
	"./school-calendar.svg": 1080,
	"./search-global-white.svg": 1081,
	"./search-global.svg": 1082,
	"./search.svg": 709,
	"./searchIcon.svg": 1083,
	"./seat-icon-2.svg": 1084,
	"./seat-icon.svg": 1085,
	"./seat-icons/3-wheelChair.png": 1086,
	"./seat-icons/block_seat_new.png": 1087,
	"./seat-icons/broken-seat-1.svg": 1088,
	"./seat-icons/broken-seat-2.svg": 1089,
	"./select-food.png": 710,
	"./settings.svg": 1090,
	"./show-password.svg": 356,
	"./slider-triangle.svg": 1091,
	"./snack.svg": 703,
	"./sort.svg": 1092,
	"./star-empty.svg": 1093,
	"./star-fill.svg": 1094,
	"./success-tick.svg": 1095,
	"./suitcase.svg": 1096,
	"./swap.svg": 1097,
	"./tick-green-item.svg": 711,
	"./tick-green.svg": 1098,
	"./ticket-icon.svg": 1099,
	"./trash.svg": 1100,
	"./unpaid-reservation.svg": 685,
	"./updown-white.svg": 1101,
	"./updown.svg": 1102,
	"./user-attribute.svg": 1103,
	"./user-attributes.svg": 1104,
	"./user-female.svg": 1105,
	"./user-male-white.svg": 1106,
	"./user-male.svg": 1107,
	"./user-profile.svg": 1108,
	"./userProfile.png": 1109,
	"./veg-food-mark-white.png": 1110,
	"./veg-foog-mark-trans.png": 1111,
	"./view.png": 1112,
	"./view.svg": 1113
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 936;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 936
// module chunks = 33